<template>
    <b-card :title="title">
        <b-card-body>
           <b-input v-model="filter" placeholder="Search Activity type..."></b-input>
            <slot></slot>

            <p class="mt-3">
                Page: {{ currentPage }} of {{ Math.ceil(rows/itemsPerPage) }} Total:
                {{  rows}}
            </p>

            <b-table :fields="fields" striped hover responsive :items="items" :per-page="itemsPerPage"
      :current-page="currentPage"  :filter="filter">
                <template #cell(id)="row">
                    <b-button
                        size="sm"
                        @click="$emit('show-item', row.item.id)"
                        class="mr-2"
                        v-if="hasPermissionCreate"
                        variant="primary"
                    >
                        View
                    </b-button>
                </template>
            </b-table>

            <b-row>
                <b-col>
                    <b-pagination
                        class="float-right"
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="itemsPerPage"
                        aria-controls="roleTable"
                        pills
                        align="right"
                    ></b-pagination>
                </b-col>
            </b-row>


        </b-card-body>
    </b-card>
</template>
<script>
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'orderTypes-ListItems',
    mixins: [popupMixins, permissionsMixins],
    props: ['type', 'items', 'title'],

    data() {
        return {
            filter: '', 
            itemsPerPage: 15,
            currentPage: 1,

            fields: [
                { key: 'id', label: 'Actions' },
                'name',
                {
                    key: 'is_default',
                    label: 'Default',
                    formatter: value => (value ? 'Yes' : 'No'),
                },
                {
                    key: 'transaction_type',
                    label: 'Transaction Type',
                    formatter: value => (value || {}).name,
                },
            ],
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        rows() {
        return this.items.length
        }


    },

    methods: {},
}
</script>
<style></style>
